export default __webpack_public_path__ + "static/staff-photo-4-24d271004f6ff3e8bd061c5518e6914d.jpg";